import config from "appConfig";
import { Slide } from "@jelly/lesson";
import theory from "../../theory";

const principle: Slide = {
  description:
    "A simple concrete wall separates two rooms. Add massive or lightweight vibration isolated lining to that wall and to other surfaces in the source room. Observe the improvement of sound insulation between the rooms expressed with DnT,w for wideband frequency range and with DnT, 63Hz for low frequencies, compared to the reference state with no lining used.",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [1, 5],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "Reference",
                  formatter: "simple",
                  scrollbars: false,
                  styles: {
                    fontWeight: 800,
                    fontSize: "14px",
                    letterSpacing: "3.5px",
                    textTransform: "uppercase",
                  },
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/28/principle/principle-1.svg`,
                },
              },
              styles: {
                width: "80%",
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
